import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TrainingService } from '../../services/training.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { StringConstants } from '@app/shared/string-constants';
import { TaskNotification } from '../../models/task-notification';

@Component({
	selector: 'kpa-safetyvideo',
	templateUrl: './safetyvideo.component.html',
	styleUrls: ['./safetyvideo.component.scss'],
})
export class SafetyVideoComponent implements OnInit {
	@Input() dialogOpened: boolean = false;
	@Output() closeDialog = new EventEmitter<void>();
	@Input() contentURL: SafeResourceUrl;
	@Input() isMarcom: boolean = false;
	@Input() scheduledId: number;
	@Output() onTaskComplete: EventEmitter<TaskNotification> = new EventEmitter<TaskNotification>();
	@ViewChild('iframe') iframe: ElementRef<HTMLIFrameElement>;
	isCheckboxChecked = false;
	showButtons = false;
	loading: boolean = true;

	constructor(
		private trainingService: TrainingService,
		private notificationService: NotificationService
	) {}

	ngOnInit() {
		this.loading = true;
	}
	public hideLoader() {
		this.loading = false;
	}
	onCheckboxChange() {
		this.showButtons = this.isCheckboxChecked;
	}
	public close(component: string): void {
		this[component + 'Opened'] = false;
		this.closeDialog.emit();
	}
	onYesClick() {
		this.trainingService.record(this.scheduledId).subscribe({
			next: (response) => {
				if (response) {
					this.close('dialog');
					const taskNotification: TaskNotification = {
						isCompleted: true,
						isReviewed: false,
					};
					this.onTaskComplete.emit(taskNotification);
				}
			},
			error: (err) => {
				this.notificationService.show({
					content: 'Error while saving training.',
					hideAfter: StringConstants.hideNotificationAfter,
					position: { horizontal: 'right', vertical: 'bottom' },
					animation: { type: 'fade', duration: 400 },
					type: { style: 'error', icon: true },
				});
			},
		});
	}

	onNoClick() {
		this.isCheckboxChecked = false;
		this.showButtons = false;
	}
}
